/* ============
 * Mutations for the vivemas module
 * ============
 *
 * The mutations that are available on the
 * vivemas module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setBenefitCategories (state, payload) {
    state.benefitCategories = payload.data
  },
  setAssistCategories (state, payload) {
    state.assistCategories = payload
  },
  setBenefits (state, payload) {
    state.benefits = payload.data
  },
  setAssists (state, payload) {
    state.assists = payload
  },
  setBrands (state, payload) {
    state.brands = payload
  },
  setCities (state, payload) {
    state.cities = payload
  },
  clear (state) {
    state.benefits = []
    state.assists = []
    state.benefitCategories = []
    state.assistCategories = []
    state.brands = []
    state.cities = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vivemas/mutations.js